<template>
    <div>
        <div class="title-lable-error">
            <span class="ml-3">Expired !</span>
        </div>
        <div
            class="d-flex flex-row mt-3 ml-3"
            style="color: #757575; font-size: 0.85rem"
        >
            <div>
                This image has expired rental plan. Please renew to continue
                using.
            </div>
        </div>
    </div>
</template>

<script>
// Lib
import { mapState } from "vuex";

// Extend
import base from "@/scripts/base";

export default {
    extends: base,

    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
};
</script>